import { useEffect } from "react"
import { Navigate, useSearchParams } from "react-router-dom"
import { observer, useLocalObservable } from "mobx-react"
import { Button, Col, Flex, Row, Typography } from "antd"
import { choose } from "choose-matching"

import { authStore } from "@src/app/authStore"
import { AuthLayout } from "@src/app/layouts/AuthLayout"
import { paths } from "@src/app/paths"
import UiStore from "@src/app/uiStore"
import { RegistrationConfirmCodeForm } from "@src/pages/registrationConfirm/ui/RegistrationConfirmCodeForm"
import { catchErrors } from "@src/shared/api"
import { checkPartner } from "@src/shared/checkPartner"
import css from "./index.module.css"
import { ConfirmStore } from "./store"

const { Title } = Typography

export const RegistrationConfirmPage = observer(() => {
  const { sendConfirmationCode } = authStore

  const [params] = useSearchParams()
  const { isTransferioTheme } = UiStore()
  const { code, email } = Object.fromEntries([...params])

  const store = useLocalObservable(() => new ConfirmStore())

  const { confirm } = store

  useEffect(() => {
    sendConfirmationCode().catch((e) => {
      const isCodeWasSent = e.response?.data?.error?.message?.includes(
        "code was sent to email",
      )

      if (!isCodeWasSent) {
        catchErrors(e)
      }
    })
  }, [])

  return (
    <AuthLayout>
      <Flex style={{ width: "100%" }} vertical>
        <Typography className={css.typography}>
          <Title className={css.title}>Verify Your Email</Title>
        </Typography>
        <Flex className={css.form}>
          <RegistrationConfirmCodeForm
            code={code}
            email={email as string}
            submit={confirm}
          />
        </Flex>
        <Flex gap={16} style={{ marginTop: 16 }} vertical>
          <Flex align="center" gap={4}>
            Code not sent?{" "}
            <Button
              id="GENERATED_ID_REGISTRATIONCONFIRM_BUTTON_CLICK_TO_RESEND_1"
              onClick={() => sendConfirmationCode().catch(catchErrors)}
              style={{ height: "auto", padding: 0 }}
              type="link"
            >
              Click to resend
            </Button>
          </Flex>

          <Flex align="center" gap={4}>
            Or contact us?{" "}
            <Typography.Link
              href={
                isTransferioTheme
                  ? "https://t.me/transferio_chat"
                  : "https://t.me/cryptix_chat"
              }
              style={{ height: "auto", padding: 0 }}
              target="_blank"
            >
              Click here
            </Typography.Link>
          </Flex>
        </Flex>
      </Flex>
    </AuthLayout>
  )
})
